import { css } from "@emotion/react";

import { Icon } from "@zapier/zinnia-icons";

import { statusMap } from "@zapier/reporting/src/constants";
import { RunStatus as RunStatusType } from "@zapier/reporting/src/graphql-types";

type Props = {
  size?: number;
  status: RunStatusType | null | undefined;
};

const root = (size: number) => css`
  align-items: center;
  display: flex;
  height: ${size}px;
  justify-content: center;
  width: ${size}px;
`;

function RunStatusIcon({ size = 30, status }: Props) {
  if (!status) return null;

  const statusInfo = statusMap[status];

  return statusInfo ? (
    <div css={[root(size)]}>
      <Icon
        color={statusInfo.iconColor}
        name={statusInfo.icon}
        size={size / 2 + 3 + (statusInfo.iconSize || 0)}
      />
    </div>
  ) : null;
}

export default RunStatusIcon;
